import {Image} from "antd";
import {useImageLoader} from "../../../components/customHook/ImageLoader";

const ThumbnailSticker = ({ thumbnailResourceId }) => {
    const { imageUrl } = useImageLoader(thumbnailResourceId)

    return (
        <Image
            width={50}
            src={imageUrl}
            preview={false}
        />
    );
}

export default ThumbnailSticker;